import React, { useState } from "react";
import { Form, Input, Button, Select, Row, Col, message, DatePicker, Spin } from "antd";
import { useHistory } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import _NewapplicationService from "../../modules/NewapplicationService";
import { routes } from "../../routes/Routes";
import moment from "moment";
import { COMMON_ERROR_MSG, SUBMISSION_FAILED } from "../../constants/constants";

const ApplicationStatus = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const res = await _NewapplicationService.getApplicationStatusByApplicationIdDOB(values.applicationId, values.dob.format("YYYY-MM-DD"));
            if (res.data.IsSuccess) {
                let resObj = res.data.Obj;
                localStorage.setItem("Id", resObj && resObj.Id);
                localStorage.setItem("ApplicationObjId", resObj && resObj.Id);
                localStorage.setItem("ApplicationEmailId", resObj && resObj.Email);
                localStorage.setItem("ApplicationStatusId", resObj && resObj.Application_Status_Id);
                localStorage.setItem("ApplicationId", resObj && resObj.ApplicationId);
                localStorage.setItem("fromUserLoginScreen", true);
                localStorage.setItem("fromBalanceSheetScreen", false);
                localStorage.setItem("applicationTypeId", resObj && resObj.App_Det_Application_Type_Id);

                setLoading(false);
                message.success("Application Status fetched successfully");
                history.push(routes.dashboard.path);
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            message.error(err.message || SUBMISSION_FAILED);
        }
        finally {
            setLoading(false);
        }
    };

    const disableFutureDates = (current) => {
        return current && current > moment().endOf("day");
    };

    return (
        <Spin spinning={loading}>
            <LeftLayout>
                <div className="w450">
                    <Row>
                        <Col span={24}>
                            <h2 style={{ fontWeight: "bold" }}>Application Status</h2>
                            <Form
                                layout="vertical"
                                onFinish={onFinish}
                                initialValues={{ applicationType: undefined }}
                                style={{ marginTop: 40 }}
                            >
                                <Form.Item
                                    label="Application Id"
                                    name="applicationId"
                                    rules={[
                                        { required: true, message: "Application Id is required" },
                                        // {
                                        //     pattern: /^\d{5}$/,
                                        //     message: "Application Id must be 5 digits",
                                        // },
                                    ]}
                                >
                                    <Input placeholder="Enter Application Id" maxLength={20} />
                                </Form.Item>

                                <Form.Item
                                    label="Date Of Birth"
                                    name="dob"
                                    rules={[{ required: true, message: "Date Of Birth is required" }]}
                                >
                                    <DatePicker
                                        style={{ width: "100%" }}
                                        placeholder="Select Date of Birth"
                                        format="MM/DD/YYYY"
                                        disabledDate={disableFutureDates}
                                    />
                                </Form.Item>


                                <Form.Item>
                                    <div style={{ marginTop: 20 }}>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            size="large"
                                            shape="round"
                                            style={{
                                                minWidth: 160,
                                                fontWeight: 600,
                                                background: "#fff",
                                                color: "#163153",
                                                border: "2px solid #163153",
                                            }}

                                        >
                                            Submit <span style={{ marginLeft: 8 }}>{'>'}</span>
                                        </Button>
                                    </div>
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </div>
            </LeftLayout>
        </Spin>
    );
};

export default ApplicationStatus;